<template>
	<div class="py-3" :class="{'border-bottom-dashed':is_border}">
    <div class="row slim-grid-row">
      <div class="col-6 col-sm-7">
        <p class="mb-1 body-2-2-1" style="color: #00000073">{{variant.variant_name}}</p>
        <p class="mb-0 body-1-4 color-black">{{formatCurrency(variant.price_sell)}}</p>
      </div>
      <div class="col-6 col-sm-5 text-center">
      	<button v-if="variant.availability == 0" class="btn w-100 body-2-4 rounded-10 py-2 text-center text-green" style="background-color: #EFEFEF" >{{$t('merchant.out-of-stock')}}</button>
        <div class="plus-min-set" v-else>
        	<img v-if="decrementActive" src="../../assets/img/icon/decrement-active.png" class="d-inline-block mr-1 border-green" width="28" style="padding: 7px;border-radius: 5px;" @click="checkBeforeDecItem()">
          <img v-else src="../../assets/img/icon/decrement.png" class="d-inline-block mr-1" width="28" style="padding: 7px;border-radius: 5px;border:1px solid #70707046;">

          <input type="text" class="d-inline-block border-none border-bottom-green text-center body-2-4 counter" @keypress="inputCustomOnly($event,'number')" style="width:45px;" v-model="qty">

          <img src="../../assets/img/icon/increment.png" class="d-inline-block border-green ml-1" width="28" style="padding: 7px;border-radius: 5px;" @click="incItem()">
        </div>
      </div>
    </div>
    <warning-box 
    	v-if="warning_reset_item_show"  
    	@no="toggleWarningReset" 
    	@yes="decItem"
    	:title="$t('warning-message.reset-item.title')"
			:body="$t('warning-message.reset-item.message')"
			:btn_primary="$t('general.yes-delete')"
			:btn_secondary="$t('general.cancel')">	
    	</warning-box>
  </div>
</template>

<script>
	import {formatCurrency,inputCustomOnly} from '@/utils/index.js'
	import {mapGetters, mapActions, mapMutations} from "vuex";
	import WarningBox from '@/components/general/WarningBox'

	export default{
		props:['data','ticket','is_border'],
		components:{
			WarningBox
		},
		data(){
			return{
				qty:0,
				variant:{},
				warning_reset_item_show: false
			}
		},
		created(){
			this.loadVariant();
		},
		computed:{
			CartItemQty(){
				return this.getTicketCart().qty;
			},
			decrementActive(){
				if (this.qty > 0) return true
				return false
			}
		},
		watch:{
			CartItemQty(){
				this.loadVariant()
			}
		},
		methods:{
			...mapGetters(['getTicketCart','getMerchant']),
			...mapActions(['ticketAddItemCart','ticketDecItemCart','ticketResetItemCart']),
			inputCustomOnly($event,value){
				inputCustomOnly(value,$event)
			},
			formatCurrency(data){
				return formatCurrency(data)
			},
			loadVariant(){
				this.variant = JSON.parse(JSON.stringify(this.data));
				let ticket_details = this.getTicketCart().ticket_details;
				this.qty = 0;
				if (ticket_details) {
					for(let i = 0; i < ticket_details.length;i++){
						if (ticket_details[i].ticket.id == this.ticket.id) {
							for(let j = 0; j < ticket_details[i].variant.length;j++){
								if (ticket_details[i].variant[j].data.id == this.variant.id) {
									this.qty = ticket_details[i].variant[j].qty;
									break
								}
							}
						}
					}
				}
			},
			incItem(){
				let data = {
					ticket: this.ticket,
					variant: this.variant
				}
				delete data.ticket.variants
				this.ticketAddItemCart(data);
			},
			checkBeforeDecItem(){
				if (this.decrementActive) {
					if (this.qty==1) {
						this.warning_reset_item_show = true
					}else{
						this.decItem()
					}
				}
			},
			decItem(){
				if (this.CartItemQty <= 1) {
					if(this.getMerchant().merchant_category_name == 'TRANSPORT'){
						this.$emit("reset-item")
					}
					this.ticketResetItemCart()
				}else{
					let data = {
						ticket: this.ticket,
						variant: this.variant
					}
					delete data.ticket.variants
					this.ticketDecItemCart(data);
				}
				this.warning_reset_item_show = false
			},
			toggleWarningReset(){
				this.warning_reset_item_show = !this.warning_reset_item_show
			}
		}
	}
</script>

<style scoped>
  .break {
    background-color: #e9ebf2;
    height: 6px;
    border-top: 1px solid #e2e2e2;
  }

  .color-black {
    color: #000 !important;
  }

  .color-bold-light {
    color: #000000A6;
  }

  .plus-min-set input {
    margin-top: 10px;
  }

	@media only screen and (max-width: 321px){
    .counter{
      width: 25px !important;
    }
  }

  /*@media only screen and (min-width: 600px){
    .counter{
      text-align: right !important;
    }
  }*/
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketVariant.vue